module.exports = __webpack_public_path__ + "static/media/trustpilot-logo.c23b1f5a.png";